export enum SpecialErrorType {
  Common = 'common',
  NotFound = 'not-found',
}
